import React from 'react';
import HeroImage from '../assets/pic.jpeg';
import backgroundImage from '../assets/john-towner-3Kv48NS4WUU-unsplash.jpg';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { Link } from 'react-scroll';

const Home = () => {
  const resumeLink = '/Resume_Ajit_Patil.pdf';

  return (
    <section
      id="home"
      className="relative min-h-screen bg-cover bg-center text-white"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black/70" />
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-950/35 via-black/20 to-blue-950/35" />

      <div className="relative z-10 max-w-screen-xl mx-auto min-h-screen px-6 pt-24 pb-20 flex flex-col-reverse md:flex-row items-center justify-center gap-12">
        <div className="flex-1 text-center md:text-left">
          <p className="uppercase tracking-[0.28em] text-cyan-300 text-sm font-semibold mb-4">
            Software Engineer
          </p>

          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight">
            Backend systems. Cloud platforms. Reliable software.
          </h1>

          <p className="mt-6 text-lg text-gray-200 max-w-2xl leading-relaxed">
            I build scalable applications with Java, Spring Boot, React, AWS,
            event-driven architecture, and cloud-native engineering — with a
            fundamentals-first approach to design, reliability, and delivery.
          </p>

          <div className="mt-8 flex flex-wrap justify-center md:justify-start gap-4">
            <Link
              to="portfolio"
              smooth
              duration={500}
              offset={-80}
              className="group inline-flex items-center gap-2 rounded-lg bg-cyan-500 px-6 py-3 font-semibold text-black cursor-pointer transition hover:bg-cyan-300"
            >
              View Projects
              <MdOutlineKeyboardArrowRight
                size={24}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </Link>

            <a
              href={resumeLink}
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-center gap-2 rounded-lg border border-white/30 bg-white/10 px-6 py-3 font-semibold backdrop-blur-sm transition hover:bg-white/20"
            >
              Resume
              <MdOutlineKeyboardArrowRight
                size={24}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>

          <div className="mt-8 flex flex-wrap justify-center md:justify-start gap-2 text-sm text-gray-300">
            {['Java', 'Spring Boot', 'AWS', 'Kafka', 'React', 'Kubernetes'].map(
              (skill) => (
                <span
                  key={skill}
                  className="rounded-full border border-white/15 bg-white/5 px-3 py-1"
                >
                  {skill}
                </span>
              ),
            )}
          </div>
        </div>

        <div className="flex-1 flex justify-center">
          <div className="relative">
            <div className="absolute -inset-3 rounded-full bg-cyan-400/20 blur-2xl" />
            <img
              src={HeroImage}
              alt="Ajit Patil"
              className="relative w-56 h-56 sm:w-72 sm:h-72 object-cover rounded-full border-4 border-white/20 shadow-2xl"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-5 left-0 right-0 z-10 text-center px-4 text-xs sm:text-sm text-gray-300">
        Built with React • CI/CD via GitHub Actions • Hosted on AWS S3 +
        CloudFront
      </div>
    </section>
  );
};

export default Home;
